import { render, staticRenderFns } from "./SocialIcon.vue?vue&type=template&id=d499f1b4&scoped=true&"
import script from "./SocialIcon.vue?vue&type=script&lang=ts&"
export * from "./SocialIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SocialIcon.vue?vue&type=style&index=0&id=d499f1b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d499f1b4",
  null
  
)

export default component.exports